import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import NotificationsOffOutlinedIcon from "@mui/icons-material/NotificationsOffOutlined";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

import { Box } from "@mui/joy";
import {
  Container,
  Grid,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useRecoilState } from "recoil";
import { HTTP_RESPONSE_CODE, NOTIFICATION_TYPE } from "../../common/const";
import { getFormattedDate } from "../../common/helper";
import { DeveloperHeader } from "../../components/DeveloperHeader";
import SideBar from "../../components/Setting/Sidebar";
import { AddWatchItemModal } from "../../components/WatchList/AddWatchItemModal";
import { useDeveloperContext } from "../../hook/useDeveloperContext";
import { watchAddressApi } from "../../openApi";
import { WatchAddress } from "../../openApi/api";
import { ShowProgress } from "../../state/ShowProgress";
import { UpdateWatchItemModal } from "../../components/WatchList/UpdateWatchItemModal";
import { RemoveWatchItemModal } from "../../components/WatchList/RemoveWatchItemModal";
import { ThemeLight } from "../../state/ThemeLight";

const PAGE_SIZE = 10;

const MyAddress = () => {
  const { userID, sessionKey, handleSessionKey } = useDeveloperContext();

  const [, setShowProgress] = useRecoilState(ShowProgress);
  const [themeLight] = useRecoilState(ThemeLight);

  const [watchAddresses, setWatchAddresses] = useState<WatchAddress[]>([]);

  const [keyword, setKeyword] = useState<string>("");

  const [pageNum, setPageNum] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);

  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [showSearchModal, setShowSearchModal] = useState<boolean>(false);
  const [showRemoveModal, setShowRemoveModal] = useState<boolean>(false);
  const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);

  const [selectedIndex, setSelectedIndex] = useState<number>();

  useEffect(() => {
    if (sessionKey !== undefined && sessionKey !== "" && userID !== 0) {
      handleRefresh();
    }
  }, [userID, sessionKey, pageNum]);

  const handleRefresh = (resetPageNum?: boolean) => {
    if (resetPageNum) {
      if (pageNum === 1) {
        watchAddressApi
          .getWatchAddresses(userID, sessionKey!, 0, PAGE_SIZE, keyword)
          .then((res) => {
            setTotal(res.data.total ?? 0);
            setWatchAddresses(res.data.addresses ?? []);
          })
          .catch((err) => {
            setShowProgress(false);
            if (err.response) {
              if (
                err.response.data.statusCode === HTTP_RESPONSE_CODE.UNAUTHORIZED
              ) {
                toast.error("Session key is expired", {
                  theme: themeLight ? "light" : "dark",
                });
                handleSessionKey("");
              } else {
                toast.error(err.response.data.message, {
                  theme: themeLight ? "light" : "dark",
                });
              }
            } else {
              toast.error(err.message, {
                theme: themeLight ? "light" : "dark",
              });
            }
          });
      } else {
        setPageNum(1);
      }
    } else {
      watchAddressApi
        .getWatchAddresses(
          userID,
          sessionKey!,
          (pageNum - 1) * PAGE_SIZE,
          PAGE_SIZE,
          keyword
        )
        .then((res) => {
          setTotal(res.data.total ?? 0);
          setWatchAddresses(res.data.addresses ?? []);
        })
        .catch((err) => {
          setShowProgress(false);
          if (err.response) {
            if (
              err.response.data.statusCode === HTTP_RESPONSE_CODE.UNAUTHORIZED
            ) {
              toast.error("Session key is expired", {
                theme: themeLight ? "light" : "dark",
              });
              handleSessionKey("");
            } else {
              toast.error(err.response.data.message, {
                theme: themeLight ? "light" : "dark",
              });
            }
          } else {
            toast.error(err.message, { theme: themeLight ? "light" : "dark" });
          }
        });
    }
  };

  return (
    <>
      <DeveloperHeader title="Watch List" />

      <Container className="container-xxl pb-16 mt-n14">
        <Grid container spacing={2}>
          <Grid item xl={3} lg={4}>
            <SideBar />
          </Grid>
          <Grid item xl={9} lg={8}>
            <Box className="card mb-4">
              <Box className="card-header d-flex justify-content-between align-items-center">
                <h3 className="card-header-title">Watch List</h3>
                <Link
                  id="ContentPlaceHolder1_addnew"
                  data-bs-toggle="modal"
                  data-bs-target="#myModal"
                  className="btn btn-primary text-nowrap"
                  onClick={() => setShowAddModal(true)}
                >
                  <AddOutlinedIcon className="text-icon me-1" /> Add
                </Link>
              </Box>
              <Box className="card-body">
                <p>
                  An Email notification can be sent to you when an address on
                  your watch list sends or receives any transactions.
                </p>

                <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
                  <span className="text-muted">
                    &nbsp;{total} address selected
                  </span>
                  <div className="d-flex gap-2">
                    <div className="dropdown order-md-2">
                      <button
                        className="btn btn-sm btn-secondary"
                        type="button"
                        id="dropdownSearchFilter"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        onClick={() => setShowSearchModal(!showSearchModal)}
                      >
                        <SearchIcon className="text-icon" />
                      </button>
                      {showSearchModal && (
                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownSearchFilter"
                          style={{
                            minWidth: "30rem",
                            position: "absolute",
                            inset: "0px 0px auto auto",
                            margin: "0px",
                            transform: "translate(0px, 31px)",
                            display: "block",
                          }}
                        >
                          <div className="input-group">
                            <input
                              className="form-control py-2"
                              id="q"
                              name="q"
                              type="search"
                              value={keyword}
                              placeholder="Search Address / Nametag / Private Nametag"
                              onChange={(e) => setKeyword(e.target.value)}
                            />
                            <button
                              type="submit"
                              className="btn btn-primary"
                              data-bs-toggle="tooltip"
                              onClick={() => {
                                handleRefresh(true);
                                setShowSearchModal(false);
                              }}
                            >
                              Find
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <TableContainer component={Paper} className="box-shadow-0">
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Address</TableCell>
                        <TableCell align="left">Name Tags</TableCell>
                        <TableCell align="left">Notification</TableCell>
                        <TableCell align="left"></TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {watchAddresses.map((data, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <div className="d-flex gap-2">
                              <div>
                                <img
                                  className="rounded-circle"
                                  width="24"
                                  src="data:image/png;base64, /9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCABAAEADASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwCjXotedV6LWyOfjn/mH/7e/wDbTwGvfq86orKnDkue5nPD/wDafJ+85eW/S+9vNdj0WvAa7miipDnsGTcP/wBmc/7zm5rdLbX833PRa86r0WvOq1Z4fA3/ADEf9u/+3BRXDV3NZQnzn3dOpznotFFeA1VSpyW0PyDJsm/tPn9/l5bdL73812PfqK8Br36inU576BnOTf2Zye/zc1+ltreb7nnVFFcNUznyH6/Uqch79XnVei0Vq0fkmRZ7/ZXtP3fNzW62ta/k+551XotFedUbH0H/ACVX/Tr2X/b1+b/wG1uXzvc9FrzqivRaNw/5JX/p77X/ALdty/8AgV783lax51XotFFCR8/nue/2r7P93y8t+t73t5LsedV6LXnVcNWU6nJ0PvOIMm/tP2fv8vLfpfe3mux79RXnVFa3PD/1G/6iP/Jf/tj0WivOqKLh/qN/1Ef+S/8A2x6LXnVcNXc1lCpz9D3OH8m/sz2nv83Nbpba/m+5/9k="
                                  alt="Address"
                                />
                              </div>
                              <div>
                                <div className="d-flex align-items-center gap-1">
                                  <a
                                    className="me-1"
                                    href="/address/0x0376bCE59EA10eDb4991571Ee2513439d78629e7"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    data-bs-trigger="hover"
                                  >
                                    <span
                                      className="text-primary"
                                      id="a_0x0376bCE59EA10eDb4991571Ee2513439d78629e7"
                                    >
                                      <span data-highlight-target="0x0376bCE59EA10eDb4991571Ee2513439d78629e7">
                                        {data.address}
                                      </span>
                                    </span>
                                  </a>{" "}
                                  <a
                                    className="js-clipboard link-secondary  "
                                    data-clipboard-text="0x0376bCE59EA10eDb4991571Ee2513439d78629e7"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-hs-clipboard-options='{ "type": "tooltip", "successText": "Copied!", "classChangeTarget": "#linkIcon_1", "defaultClass": "fa-copy", "successClass": "fa-check" }'
                                    aria-label="Copy Address"
                                    onClick={() => {
                                      navigator.clipboard
                                        .writeText(data.address)
                                        .then(() =>
                                          toast.success("Copied", {
                                            theme: themeLight
                                              ? "light"
                                              : "dark",
                                          })
                                        );
                                    }}
                                  >
                                    <ContentCopyOutlinedIcon className="text-icon" />{" "}
                                  </a>
                                </div>
                                <div className="small mt-1">
                                  <span className="text-muted">Added on:</span>{" "}
                                  {getFormattedDate(data.createdAt)}
                                </div>
                                <div className="small mt-1">
                                  <span className="text-muted">
                                    Address Balance:{" "}
                                  </span>
                                  <a
                                    className="btn btn-sm btn-secondary fs-80x fw-medium"
                                    href="/tokenholdings?a=0x0376bCE59EA10eDb4991571Ee2513439d78629e7"
                                    target="_blank"
                                    data-bs-toggle="tooltip"
                                    data-bs--placement="top"
                                    data-bs-trigger="hover"
                                  >
                                    $0.00
                                  </a>
                                </div>
                                {data.description && (
                                  <div className="small mt-1">
                                    <span className="text-muted">Note: </span>
                                    <span id="spanDesc_0x0376bCE59EA10eDb4991571Ee2513439d78629e7">
                                      {data.description}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </TableCell>
                          <TableCell>
                            <span className="badge bg-light border border-dark dark:border-white border-opacity-10 text-dark fw-normal fs-sm rounded-pill py-1.5">
                              <span className="hash-tag text-truncate">
                                test
                              </span>
                            </span>
                          </TableCell>
                          <TableCell className="text-nowrap">
                            <div className="d-flex align-items-center">
                              {data.notificationType ===
                              NOTIFICATION_TYPE.NONE ? (
                                <NotificationsOffOutlinedIcon className="me-2 text-icon" />
                              ) : (
                                <MailOutlineIcon className="me-2 text-icon" />
                              )}

                              {data.notificationType === NOTIFICATION_TYPE.NONE
                                ? "None"
                                : "Email"}
                            </div>
                          </TableCell>

                          <TableCell className="text-end">
                            <Link
                              className="btn btn-sm btn-white me-1"
                              href="#"
                              onClick={() => {
                                setSelectedIndex(index);
                                setShowUpdateModal(true);
                              }}
                            >
                              <EditIcon className="fa-fw" />
                            </Link>
                            <Link
                              className="btn btn-sm btn-white text-danger "
                              href="#"
                              onClick={() => {
                                setSelectedIndex(index);
                                setShowRemoveModal(true);
                              }}
                            >
                              <DeleteIcon className="fa-fw my-auto" />
                            </Link>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              <Box className="card-body">
                <Box className="d-flex flex-wrap align-items-center justify-content-end gap-3">
                  <Box className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                    <Box className="pagination pagination-sm mb-0">
                      <Box
                        className={`page-item ${
                          pageNum === 1 ? "disabled" : ""
                        }`}
                        onClick={() => setPageNum(1)}
                      >
                        <span className="page-link">First</span>
                      </Box>
                      <Box
                        className={`page-item ${
                          pageNum === 1 ? "disabled" : ""
                        }`}
                        onClick={() => {
                          if (pageNum === 1) {
                            return;
                          }

                          setPageNum(pageNum - 1);
                        }}
                      >
                        <span className="page-link px-3">
                          <ChevronLeftIcon className="text-icon small" />
                        </span>
                        <span className="sr-only">Previous</span>
                      </Box>
                      <Box className="page-item disabled">
                        <span className="page-link text-nowrap">
                          Page {pageNum} of {Math.ceil(total / PAGE_SIZE)}
                        </span>
                      </Box>
                      <Box
                        className={`page-item ${
                          pageNum === Math.ceil(total / PAGE_SIZE)
                            ? "disabled"
                            : ""
                        }`}
                        onClick={() => {
                          if (pageNum === Math.ceil(total / PAGE_SIZE)) {
                            return;
                          }

                          setPageNum(pageNum + 1);
                        }}
                      >
                        <span className="page-link px-3">
                          <ChevronRightIcon className="text-icon small" />
                        </span>
                        <span className="sr-only">Next</span>
                      </Box>
                      <Box
                        className={`page-item ${
                          pageNum === Math.ceil(total / PAGE_SIZE)
                            ? "disabled"
                            : ""
                        }`}
                        onClick={() => {
                          if (pageNum === Math.ceil(total / PAGE_SIZE)) {
                            return;
                          }

                          setPageNum(Math.ceil(total / PAGE_SIZE));
                        }}
                      >
                        <span className="page-link">Last</span>
                        <span className="sr-only">Last</span>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <AddWatchItemModal
        open={showAddModal}
        handleOpen={setShowAddModal}
        handleRefresh={handleRefresh}
      />
      <UpdateWatchItemModal
        open={showUpdateModal}
        handleOpen={setShowUpdateModal}
        handleRefresh={handleRefresh}
        watchAddress={
          selectedIndex !== undefined && selectedIndex < watchAddresses.length
            ? watchAddresses[selectedIndex]
            : undefined
        }
      />
      <RemoveWatchItemModal
        open={showRemoveModal}
        handleOpen={setShowRemoveModal}
        handleRefresh={handleRefresh}
        watchAddress={
          selectedIndex !== undefined && selectedIndex < watchAddresses.length
            ? watchAddresses[selectedIndex]
            : undefined
        }
      />
    </>
  );
};

export default MyAddress;
